import React, { useState, useEffect } from 'react';
import { Form, Select, Row, Tag, Button, Input, Col, Tooltip } from 'antd';
import propTypes from 'prop-types';

import { getAiInstructions } from '../../utils/api.js';

const defaultInstruction = {
	id: 'default',
	name: 'Standard',
	value:
		'Summera följande text, svara på svenska, med en professionell tonalitet samt korrekt grammatik och stavning.',
};

const customInstruction = {
	id: 'custom',
	name: 'Fritext',
	value: '',
};

function InstructionSelect({ onChange, type, multiple }) {
	const [instructions, setInstructions] = useState([defaultInstruction, customInstruction]);
	const [selectedInstructions, setSelectedInstructions] = useState([]);
	const [selectedIndex, setSelectedIndex] = useState(null);
	const [customInstructionValue, setCustomInstructionValue] = useState('');

	useEffect(() => {
		const fetchData = async () => {
			const newInstructions = await getAiInstructions(type);
			if (newInstructions) {
				const enabledInstructions = newInstructions.filter((instruction) => instruction.enabled);
				setInstructions([...enabledInstructions, customInstruction]);
			}
		};

		try {
			fetchData();
		} catch (error) {
			console.error(error);
		}
	}, []);

	const selectCustomInstruction = (index) => {
		if (!customInstructionValue || index !== instructions.length - 1) {
			return;
		}

		const customInstructionCount = selectedInstructions.filter(
			(instruction) => instruction.id.includes(customInstruction.name) && instruction.id !== customInstruction.id
		).length;

		const newSelected = [
			...selectedInstructions,
			{
				id: `${customInstruction.name}_${customInstructionCount + 1}`,
				name: `${customInstruction.name} ${customInstructionCount + 1}`,
				instruction: customInstructionValue,
			},
		];

		setSelectedInstructions(newSelected);

		setCustomInstructionValue('');
	};

	const removeInstruction = (id) => {
		setSelectedInstructions(selectedInstructions.filter((instruction) => instruction.id !== id));
	};

	useEffect(() => {
		if (selectedIndex !== null) {
			if (!multiple) {
				setSelectedInstructions([instructions[selectedIndex]]);
			}

			if (multiple && selectedIndex !== instructions.length - 1) {
				setSelectedInstructions([...selectedInstructions, instructions[selectedIndex]]);
			}
		}
	}, [selectedIndex]);

	useEffect(() => {
		const selected = multiple ? selectedInstructions : selectedInstructions.slice(-1);
		onChange(selected);
	}, [selectedInstructions]);

	return (
		<div>
			<Col xl={10} xxl={24} style={{ padding: 0 }}>
				<Form.Item label='Tillgängliga instruktioner'>
					<Row>
						<Select
							size='default'
							style={{ width: '100%' }}
							defaultActiveFirstOption={true}
							value={selectedIndex || 'Välj instruktion'}
							onSelect={(index) => setSelectedIndex(index)}
						>
							{instructions.map((instruction, index) => {
								if (selectedInstructions.includes(instruction)) {
									return null;
								}

								return (
									<Select.Option key={instruction.id} value={index}>
										<Tooltip
											placement='right'
											title={instruction.instruction}
											overlayStyle={{ marginLeft: 10 }}
										>
											<span style={{ width: '100%', display: 'block' }}>{instruction.name}</span>
										</Tooltip>
									</Select.Option>
								);
							})}
						</Select>
					</Row>
					{selectedIndex === instructions.length - 1 && (
						<div>
							<Row>
								<Input.TextArea
									autosize={false}
									style={{ minHeight: 100 }}
									value={instructions[selectedIndex].instruction || customInstructionValue}
									onChange={(e) => setCustomInstructionValue(e.target.value)}
								/>
							</Row>
							<Row>
								<Button.Group style={{ float: 'right', marginTop: 4}}>

								<Button
									onClick={() => {
										setSelectedIndex(null);
										setCustomInstructionValue('');
									}}
									
									>
									Avbryt
								</Button>
								<Button
									onClick={() => selectCustomInstruction(selectedIndex)}
									
									type='primary'
									>
									Lägg till
								</Button>
								</Button.Group>
							</Row>
						</div>
					)}
				</Form.Item>
			</Col>
			{multiple && (
				<Col xl={14} xxl={24}>
					<Form.Item label='Valda instruktioner'>
						<Row>
							{selectedInstructions.map((instruction) => (
								<Tag
									key={instruction.id}
									closable
									onClose={() => removeInstruction(instruction.id)}
									style={{ fontSize: 14 }}
								>
									<Tooltip key={instruction.id} title={instruction.instruction}>
										{instruction.name}
									</Tooltip>
								</Tag>
							))}

							{selectedInstructions.length === 0 && <span>- Ingen instruktion vald -</span>}
						</Row>
					</Form.Item>
				</Col>
			)}
		</div>
	);
}

InstructionSelect.defaultProps = {
	onChange: () => {},
	type: null,
};

InstructionSelect.propTypes = {
	onChange: propTypes.func,
	type: propTypes.string,
};

export { InstructionSelect, InstructionSelect as default };



// WEBPACK FOOTER //
// ./src/components/ai/InstructionSelect.jsx